import { render, staticRenderFns } from "./_base-alert.vue?vue&type=template&id=6b7d3557&scoped=true"
import script from "./_base-alert.vue?vue&type=script&lang=js"
export * from "./_base-alert.vue?vue&type=script&lang=js"
import style0 from "./_base-alert.vue?vue&type=style&index=0&id=6b7d3557&prod&lang=scss&module=true"
import style1 from "./_base-alert.vue?vue&type=style&index=1&id=6b7d3557&prod&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6b7d3557",
  null
  
)

export default component.exports